import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css'
import axios from 'axios';
import {toast} from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

export default function Login() {
  const navigate = useNavigate()
  
  const [data, setData] = useState({
    email : '',
    password : ''
  })

  const handleInputChange = (e)=>{
    setData({...data, [e.target.name]: e.target.value})
  }
  
  const handleSubmit = async (event)=>{
    event.preventDefault();
    const {email, password} = data

    try{
      await authService.login(email, password).then(()=>{
        toast.success('Login Successfull. Welcome')
        navigate('/subscriptions')
        window.location.reload();
      }, 
      (error)=>{console.log(error)}
      )      
    }catch(error){
      console.log(error)
    }
  }

  return (
    <div className="container">
      <div className="screen">
        <div className="screen__content">
          <Form className="login">
            <div className="login__field">
              <i className="login__icon fas fa-user"></i>
              <Form.Control type="text" name='email' onChange={handleInputChange} className="login__input" placeholder="User name / Email"/>
            </div>
            <div className="login__field">
              <i className="login__icon fas fa-lock"></i>
              <Form.Control type="password" name='password' onChange={handleInputChange} className="login__input" placeholder="Password"/>
            </div>
            <Button className="button login__submit" onClick={handleSubmit}>
              <span className="button__text">Log In Now</span>
              <i className="button__icon fas fa-chevron-right"></i>
            </Button>				
          </Form>
        </div>	
      </div>
   </div>
  )
}
